Namespace 'CemSurveys'
URL =
class CemSurveys.CemSurveyItem extends Backbone.Model

class CemSurveys.CemSurveyItemCollection extends Backbone.Collection
  model: CemSurveys.CemSurveyItem

  initialize: (cemSurveyId) ->
    @cemSurveyId = cemSurveyId
    super

  updatePositions: (originalPosition, newPosition) ->
    return this if originalPosition == newPosition
    temp = @at(originalPosition)
    @remove(temp, { silent: true })
    @add(temp, { at: newPosition, silent: true })
    return @sortInServer()

  sortInServer: ->
    Backbone.ajax({
      url: "/keepcon/surveys/#{@cemSurveyId}/sort_items",
      method: 'POST',
      data: { ids: @pluck('id') },
      dataType: "json",
    });
